function overlayInit() {
	var container = $(".js-overlay-container");
	const overlay = document.querySelectorAll(".js-overlay");
	if (overlay.length > 0) {
		overlay.forEach((item) => {
			const itemMotion = new Motio(item, {
				fps: 30,
				speedX: -15,
				speedY: 0,
				bgWidth: 2880,
				bgHeight: 650,
			});

			var prevClassState = item.classList.contains("js-overlay-active");
			var observer = new MutationObserver(function(mutations) {
				mutations.forEach(function(mutation) {
					if (mutation.attributeName == "class") {
						var currentClassState = mutation.target.classList.contains(
							"js-overlay-active"
						);
						if (prevClassState !== currentClassState) {
							prevClassState = currentClassState;
							if (currentClassState) {
								itemMotion.play();
							} else {
								itemMotion.pause();
							}
						}
					}
				});
			});
			observer.observe(item, { attributes: true });
		});
	}
}
